module.exports = __webpack_public_path__ + "img/iconYeWuYueYuShenHe.692a6eda.svg";